export const blinkConstants = {
    ORG_ID_REGEX: '/(?:&|^)orgId=[^&]*/',
    DEFAULT_DATA_BATCH_SIZE: 1000,
    DEFAULT_DEBOUNCING_TIME: 500,
    MAX_PICTURE_SIZE_POST_SCALE: 4,
    METADATA_SPECIAL_GROUP: 'SPECIAL_GROUP',
    ACTIVE_SESSION_CHECK_TIME_PERIOD: 30 * 1000,
    ILLUSTRATION_PATH: '/node_modules/@thoughtspot/radiant/widgets/resources/img/illustrations/no-result.svg',
    URL_CAPTION_REGEX: /{caption}(.*){\/caption}/,
    URL_REGEX: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,63}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/={}]*)$/,
    METADATA_ANSWER_TYPE: 'answers',
    METADATA_PINBOARDS_TYPE: 'pinboards',
    METADATA_PAGE_SIZE: 20,
    ANSWER_TYPE: 'answer',
    IMPORTED_DATA_TYPE: 'imported-data',
    INSIGHT_TYPE: 'insight',
    SAVED_ANSWER_TYPE: 'saved-answer',
    PINBOARD_TYPE: 'pinboard',
    RELATED_LINK_TYPE: 'relatedLinkType',
    UNIVERSAL_SEARCH_TYPE: 'universal-search',
    SEARCH_ASSIST_ANSWER: 'search-assist-answer',
    VIEW_TYPE: 'view',
    WORKSHEET_TYPE: 'worksheet',
    SQLVIEW: 'sql-view',
    LESSON_PLAN_URL_PREFIX: 'data/tables',
    DATA_TABLES_URL_PREFIX: 'data/tables',
    embedEvents: {
        AppInit: 'appInit',
        AuthInit: 'authInit',
        AuthExpire: 'ThoughtspotAuthExpired',
        AuthFailure: 'ThoughtspotAuthFailure',
        AuthSuccess: 'ThoughtspotAuthSuccess',
        AuthLogout: 'ThoughtspotAuthLogout',
        Data: 'data',
        Error: 'Error',
        QueryChanged: 'queryChanged',
        Drilldown: 'drillDown',
        VizPointDoubleClick: 'vizPointDoubleClick',
        VizPointClick: 'vizPointClick',
        VizPointRightClick: 'vizPointRightClick',
        DataSourceSelected: 'dataSourceSelected',
        FreeTrialSpotterQuestionsExhausted: 'freeTrialSpotterQuestionsExhausted',
        TryFreeTrialSpotter: 'tryFreeTrialSpotter',
        AddRemoveColumns: 'addRemoveColumns',
        QueryReset: 'query-reset',
        SourceListOpened: 'source-list-opened',
        CustomAction: 'customAction',
        SAMLComplete: 'samlComplete',
        EmbedIframeCenter: 'EmbedIframeCenter',
        DialogOpen: 'dialog-open',
        DialogClose: 'dialog-close',
        RouteChange: 'ROUTE_CHANGE',
        NO_COOKIE_ACCESS: 'noCookieAccess',
        LiveboardRendered: 'PinboardRendered',
        TableVizRendered: 'TableVizRendered',
        EMBED_HEIGHT: 'EMBED_HEIGHT',
        GET_DATA_CLICK: 'getDataClick',
        AskSageInit: 'AskSageInit',
        IdleSessionTimeout: 'IdleSessionTimeout',
        Save: 'save',
        Download: 'download',
        DownloadAsPng: 'downloadAsPng',
        DownloadAsPdf: 'downloadAsPdf',
        DownloadPinboardAsPdf: 'downloadPinboardAsPdf',
        DownloadLiveboardAsContinuousPDF: 'downloadLiveboardAsContinuousPDF',
        DownloadLiveboardAsA4Pdf: 'downloadLiveboardAsA4Pdf',
        DownloadAsCsv: 'downloadAsCsv',
        DownloadAsXlsx: 'downloadAsXlsx',
        AnswerDelete: 'answerDelete',
        Pin: 'pin',
        SpotIQAnalyze: 'spotIQAnalyze',
        CLEAR_INFO_CACHE: 'clearInfoCache',
        Share: 'share',
        DrillInclude: 'context-menu-item-include',
        DrillExclude: 'context-menu-item-exclude',
        CopyToClipboard: 'context-menu-item-copy-to-clipboard',
        CrossFilterChanged: 'cross-filter-changed',
        UpdateTML: 'updateTSL',
        EditTML: 'editTSL',
        ExportTML: 'exportTSL',
        SaveAsView: 'saveAsView',
        CopyAEdit: 'copyAEdit',
        ShowUnderlyingData: 'showUnderlyingData',
        AnswerChartSwitcher: 'answerChartSwitcher',
        CreateMonitor: 'createMonitor',
        ManageMonitor: 'manageMonitor',
        CreateMonitorSuccess: 'createMonitorSuccess',
        Alert: 'alert',
        AddToFavorites: 'addToFavorites',
        CopyLink: 'embedDocument',
        Present: 'present',
        Remove: 'delete',
        Rename: 'rename',
        LiveboardInfo: 'pinboardInfo',
        Schedule: 'subscription',
        SchedulesList: 'schedule-list',
        Edit: 'edit',
        Explore: 'explore',
        MakeACopy: 'makeACopy',
        Cancel: 'cancel',
        SyncToSheets: 'sync-to-sheets',
        SyncToOtherApps: 'sync-to-other-apps',
        ManagePipelines: 'manage-pipeline',
        InsertInToSlide: 'insertInToSlide',
        FilterChanged: 'filterChanged',
        SageEmbedQuery: 'sageEmbedQuery',
        SageWorksheetUpdated: 'sageWorksheetUpdated',
        SavePersonalisedView: 'savePersonalisedView',
        DeletePersonalisedView: 'deletePersonalisedView',
        UpdatePersonalisedView: 'updatePersonalisedView',
        ChangePersonalisedView: 'changePersonalisedView',
        ResetLiveboard: 'resetLiveboard',
        SyncToSlack: 'syncToSlack',
        SyncToTeams: 'syncToTeams',
        UpdateConnection: 'updateConnection',
        CreateConnection: 'createConnection',
        CreateWorksheet: 'createWorksheet',
        CreateModel: 'createModel',
        ShowVersionHistory: 'showVersionHistory',
        EnableVersionControl: 'enableVersionControl',
        DisableVersionControl: 'disableVersionControl',
        OnBeforeGetVizDataIntercept: 'onBeforeGetVizDataIntercept',
        ParameterChanged: 'parameterChanged',
        OrgSwitched: 'orgSwitched',
        CDWOAuthComplete: 'CDWOAuthComplete',
        OnAutomaticOAuthPageLoad: 'OnAutomaticOAuthPageLoad',
        CreateLiveboard: 'createLiveboard',
        DynamicCssNodeReady: 'DynamicCssNodeReady',
        ResetSpotterConversation: 'ResetSpotterConversation',
        PreviewSpotterData: 'PreviewSpotterData',
        AddToCoaching: 'addToCoaching',
        DataModelInstructions: 'DataModelInstructions',
        SpotterQueryTriggered: 'SpotterQueryTriggered',
        LastPromptEdited: 'LastPromptEdited',
        LastPromptDeleted: 'LastPromptDeleted',
        RequestVisibleEmbedCoordinates: 'requestVisibleEmbedCoordinates',
        ExitPresentMode: 'exitPresentMode',
        SpotterInit: 'spotterInit',
        SpotterConversationRenamed: 'spotterConversationRenamed',
        SpotterConversationDeleted: 'spotterConversationDeleted',
        SpotterConversationSelected: 'spotterConversationSelected',
        SpotterLoadComplete: 'spotterLoadComplete',
        SpotterQueryStopped: 'spotterQueryStopped',
        SpotterSidebarToggled: 'spotterSidebarToggled',
        UpdateEmbedParams: 'updateEmbedParams',
        EmbedListenerReady: 'EmbedListenerReady',
        EmbedDestroyed: 'EmbedDestroyed',
        Publish: 'publish',
        Unpublish: 'unpublish',
        ApiIntercept: 'ApiIntercept',
        AIHighlights: 'AIHighlights',
        EmbedPageContextChanged: 'EmbedPageContextChanged',
        RefreshAuthToken: 'RefreshAuthToken',
        AllColumnDetails: 'AllColumnDetails',
        SendTestScheduleEmail: 'sendTestScheduleEmail',
        RefreshLiveboardBrowserCache: 'refreshLiveboardBrowserCache',
        SpotterVizInit: 'SpotterVizInit',
        SpotterVizQueryTriggered: 'SpotterVizQueryTriggered',
        SpotterVizResponseComplete: 'SpotterVizResponseComplete',
        SpotterVizCheckpointCreated: 'SpotterVizCheckpointCreated',
        SpotterVizCheckpointRestored: 'SpotterVizCheckpointRestored',
        SpotterVizError: 'SpotterVizError',
        SpotterVizClosed: 'SpotterVizClosed',
    },
    embedActions: {
        EditSageAnswer: 'editSageAnswer',
        SageAnswerFeedback: 'sageAnswerFeedback',
        ModifySageAnswer: 'modifySageAnswer',
        ShowSageQuery: 'showSageQuery',
        PreviewDataSpotter: 'previewDataSpotter',
        DataModelInstructions: 'DataModelInstructions',
        ResetSpotterChat: 'resetSpotterChat',
        SpotterFeedback: 'spotterFeedback',
        EditPreviousPrompt: 'editPreviousPrompt',
        DeletePreviousPrompt: 'deletePreviousPrompt',
        SpotterChatRename: 'spotterChatRename',
        SpotterChatDelete: 'spotterChatDelete',
        SpotterChatMenu: 'spotterChatMenu',
        SpotterNewChat: 'spotterNewChat',
        SpotterSidebarToggle: 'spotterSidebarToggle',
        SpotterDocs: 'spotterDocs',
        SpotterSidebarHeader: 'spotterSidebarHeader',
        SpotterSidebarFooter: 'spotterSidebarFooter',
        SpotterPastChatBanner: 'spotterPastChatBanner',
        SendTestScheduleEmail: 'sendTestScheduleEmail',
        RefreshLiveboardBrowserCache: 'refreshLiveboardBrowserCache',
        SpotterAnalystShare: 'spotterAnalystShare',
        SpotterAnalystEdit: 'spotterAnalystEdit',
        SpotterAnalystCreate: 'spotterAnalystCreate',
        SpotterAnalystDelete: 'spotterAnalystDelete',
        SpotterAnalystMakeACopy: 'spotterAnalystMakeACopy',
        SpotterAnalystSidebar: 'spotterAnalystSidebar',
    },
    ANSWER_DISPLAY_MODE_PREFERENCE_KEY: 'answer-display-mode-preference-key',
    FILE_TYPE: {
        CSV: 'csv',
        XLS: 'xls',
        PDF: 'pdf',
        XLSX: 'xlsx',
    },
    defaultAdminEmail: 'admin@thoughtspot.com',
    defaultProductName: 'ThoughtSpot',
    PieChartCardinalityThreshold: 50,
    LEFT_PANEL_GROUPING_THRESHOLD: 75,
    headline: {
        MAX_PIXEL_WIDTH_SUMMARY_VALUE: 100,
    },
    join: {
        allTables: 'all-tables',
    },
    schemaType: {
        TABLE: 'table',
        WORKSHEET: 'worksheet',
        ANSWER: 'answer',
    },
    chartScreen: {
        HD_MIN: 720,
        FHD_MIN: 1600,
        QHD_MIN: 1920,
        UHD_MIN: 2560,
    },
    metadataListPage: {
        jobRunColId: {
            START_TIME: 'startTimeCol',
            END_TIME: 'endTimeCol',
            STATE: 'stateCol',
        },
        jobRunColClass: {
            START_TIME: 'bk-job-start-time',
            END_TIME: 'bk-job-end-time',
            STATE: 'bk-job-run-state',
        },
        jobColId: {
            STATE: 'stateCol',
            CRON_SCHEDULE: 'cronScheduleCol',
            RECIPIENT: 'recipientCol',
        },
        jobColClass: {
            STATE: 'bk-job-state',
            CRON_SCHEDULE: 'bk-job-cron-schedule',
            RECIPIENT: 'bk-job-recipient',
        },
        listColId: {
            ACCOUNT_ACTIVATION: 'accountActivationCol',
            NAME: 'nameCol',
            DISPLAYED_NAME: 'displayedNameCol',
            DESCRIPTION: 'descriptionCol',
            DATE: 'dateCol',
            CREATED_AT: 'dateCreatedCol',
            CONNECTION_ICON: 'connectionIconCol',
            CONNECTOR: 'connectorCol',
            MODIFIED: 'dateModifiedCol',
            MATERIALIZED: 'materializeStatusCol',
            AUTHOR: 'authorCol',
            PROVIDED_BY: 'providedByCol',
            STICKERS: 'stickersCol',
            SOURCE: 'sourceCol',
            JOINS: 'joins',
            DATA_SOURCE_TYPE: 'dataSourceTypeCol',
            DATA_SOURCE_SCHEDULED: 'dataSourceScheduledCol',
            DATA_SOURCE_LOAD_STATUS: 'dataSourceLoadStatusCol',
            STATUS_VIEWER_LOAD_STATUS: 'statusViewerLoadStatusCol',
            DATA_FILTER_TABLE: 'dataFilterTableCol',
            DATA_FILTER_COLUMN: 'dataFilterColumnCol',
            DATA_FILTER_CONDITION: 'dataFilterConditionCol',
            DATA_FILTER_TEXT: 'dataFilterTextCol',
            JOB_OPERATION: 'jobOperation',
            TRANSFORMATION_EDITOR_COLUMN: 'transformationEditorColumnCol',
            TRANSFORMATION_EDITOR_TABLE: 'transformationEditorTableCol',
            TRANSFORMATION_EDITOR_EXPRESSION: 'transformationEditorExpressionCol',
            A3_JOB_RESULT: 'a3JobResult',
            A3_JOB_RUN_RESULT: 'a3JobRunResult',
            A3_FEEDBACK: 'A3Feedback',
            A3_FEEDBACK_RATING: 'A3FeedbackRating',
            A3_WATCH_MGMT_CHART: 'A3WatchMgmtChart',
            A3_WATCH_MGMT_CHANGE: 'A3WatchMgmtChange',
            A3_WATCH_MGMT_LAST_RUN: 'A3WatchMgmtLastRun',
            A3_WATCH_MGMT_AUTHOR: 'A3WatchMgmtAuthor',
            EMBRACE_TABLE_ICON: 'embraceTableIconCol',
            EMBRACE_TABLE_LAST_SYNC: 'embraceLastSyncCol',
            EMBRACE_TABLE_LAST_MODIFIED: 'embraceLastModifiedCol',
            EMBRACE_TABLE_ACTIONS: 'embraceTableActions',
            EMBRACE_SYNC_LIST_STATUS: 'embraceSyncListStatusCol',
            EMBRACE_SYNC_LIST_LAST_UPDATED: 'embraceSyncListLastUpdatedCol',
            EMBRACE_SYNC_LIST_TYPE: 'embraceSyncListTypeCol',
            EMBRACE_SYNC_LIST_ACTIONS: 'embraceSyncListActionsCol',
            EMBRACE_HISTORY_SCHEDULED: 'embraceHistoryScheduledCol',
            EMBRACE_HISTORY_ROWS: 'embraceHistoryNoOfRowsCol',
            EMBRACE_HISTORY_TIME_TAKEN: 'embraceHistoryTimeTakenCol',
            EMBRACE_HISTORY_STATUS: 'embraceHistoryStatusCol',
            EMBRACE_DATA_UPLOAD_STATUS: 'embraceDataUploadStatusCol',
            RESOLVED_STATUS: 'resolvedStatusCol',
            EXPERTS: 'expertsCol',
            DEFAULT_PINBOARD: 'defaultPinboards',
        },
        listColClass: {
            ACCOUNT_ACTIVATION: 'bk-account-activation',
            NAME: 'bk-name',
            DISPLAYED_NAME: 'bk-display-name',
            DESCRIPTION: 'bk-description',
            DATE: 'bk-time-and-author',
            CREATED_AT: 'bk-time-and-author',
            CONNECTION_ICON: 'bk-connection-icon',
            CONNECTOR: 'bk-connector',
            MODIFIED: 'bk-time-and-author',
            MATERIALIZED: 'bk-view-status',
            AUTHOR: 'bk-profile-pic-container',
            PROVIDED_BY: 'bk-profile-pic-container',
            STICKERS: 'bk-list-label',
            SOURCE: 'bk-list-source',
            JOINS: 'bk-num-joins',
            DATA_SOURCE_TYPE: 'bk-ds-type',
            DATA_SOURCE_SCHEDULED: 'bk-ds-scheduled',
            DATA_SOURCE_LOAD_STATUS: 'bk-ds-load-status',
            STATUS_VIEWER_LOAD_STATUS: 'bk-status-viewer-load-status',
            DATA_FILTER_TABLE: 'bk-data-filter-table',
            DATA_FILTER_COLUMN: 'bk-data-filter-column',
            DATA_FILTER_CONDITION: 'bk-data-filter-condition',
            DATA_FILTER_TEXT: 'bk-data-filter-text',
            JOB_OPERATION: 'bk-job-operations',
            TRANSFORMATION_EDITOR_COLUMN: 'bk-transformation-editor-column',
            TRANSFORMATION_EDITOR_TABLE: 'bk-transformation-editor-table',
            TRANSFORMATION_EDITOR_EXPRESSION: 'bk-transformation-editor-expression',
            A3_JOB_RESULT: 'bk-a3-job-result',
            A3_JOB_RUN_RESULT: 'bk-a3-job-run-result',
            A3_FEEDBACK: 'bk-a3-feedback-tab-feedback-column',
            A3_FEEDBACK_RATING: 'bk-a3-feedback-rating',
            A3_WATCH_MGMT_CHART: 'bk-a3-watch-mgmt-chart',
            A3_WATCH_MGMT_CHANGE: 'bk-a3-watch-mgmt-change',
            A3_WATCH_MGMT_LAST_RUN: 'bk-a3-watch-mgmt-last-run',
            A3_WATCH_MGMT_AUTHOR: 'bk-a3-watch-mgmt-author',
            EMBRACE_TABLE_ICON: 'bk-embrace-table-icon',
            EMBRACE_TABLE_TYPE: 'bk-embrace-table-type',
            EMBRACE_TABLE_LAST_SYNC: 'bk-embrace-table-last-sync',
            EMBRACE_TABLE_LAST_MODIFIED: 'bk-embrace-table-last-modified',
            EMBRACE_TABLE_ACTIONS: 'bk-embrace-table-actions',
            EMBRACE_SYNC_LIST_STATUS: 'bk-embrace-sync-list-status',
            EMBRACE_SYNC_LIST_LAST_UPDATED: 'bk-embrace-sync-list-last-updated',
            EMBRACE_SYNC_LIST_TYPE: 'bk-embrace-sync-list-type',
            EMBRACE_SYNC_LIST_ACTIONS: 'bk-embrace-sync-list-actions',
            EMBRACE_HISTORY_SCHEDULED: 'bk-embrace-history-scheduled-on',
            EMBRACE_HISTORY_ROWS: 'bk-embrace-history-rows-retrieved',
            EMBRACE_HISTORY_TIME_TAKEN: 'bk-embrace-history-time-taken',
            EMBRACE_HISTORY_STATUS: 'bk-embrace-history-status',
            EMBRACE_DATA_UPLOAD_STATUS: 'bk-embrace-data-upload-column',
            RESOLVED_STATUS: 'bk-resolved-status',
            EXPERTS: 'bk-experts-list',
            DEFAULT_PINBOARD: 'bk-default-pinboard',
        },
        autoRefresh: {
            A3_JOB_REFRESH_MS: 5000,
        },
        pinboards: {
            button: {
                icon: 'rd-icon-add-l',
                iconSize: 'l',
                iconType: 'info',
                class: 'bk-create-new-pinboard',
            },
        },
        relatedLink: {
            button: {
                icon: 'rd-icon-add-l',
                iconSize: 'l',
                iconType: 'info',
                class: 'bk-create-new-related-link',
            },
        },
        dataManagement: {
            tables: {
                tabId: 'tablesTab',
            },
            dataSources: {
                tabId: 'dataSourcesTab',
            },
            embrace: {
                tabId: 'embraceTab',
            },
            dataflow: {
                tabId: 'dataflowTab',
            },
            spotApp: {
                tabId: 'spotAppTab',
            },
            privileges: {
                DATAMANAGEMENT: 'DATAMANAGEMENT',
                ADMINISTRATION: 'ADMINISTRATION',
                SYSTEMMANAGEMENT: 'SYSTEMMANAGEMENT',
            },
        },
        embrace: {
            button: {
                icon: 'rd-icon-add-l',
                iconSize: 'l',
                iconType: 'info',
            },
        },
        jobs: {
            button: {
                icon: 'rd-icon-add-l',
                iconSize: 'l',
                iconType: 'info',
                class: 'bk-create-new-job',
            },
        },
        actions: {
            share: {
                icon: 'share',
                buttonSize: 'm',
            },
            delete: {
                icon: 'trash-can',
                buttonSize: 'm',
            },
            tag: {
                icon: 'tag',
                class: 'bk-apply-label-btn',
                buttonSize: 'm',
            },
            reset: {
                icon: 'reset',
                buttonSize: 'm',
            },
            abort: {
                icon: 'cross',
                buttonSize: 'm',
            },
            schedule: {
                icon: 'agenda',
                buttonSize: 'm',
            },
            pause: {
                icon: 'pause',
                class: 'bk-pause-job-btn',
                buttonSize: 'm',
            },
            resume: {
                icon: 'play',
                class: 'bk-resume-job-btn',
                buttonSize: 'm',
            },
            export: {
                icon: 'download',
                buttonSize: 'm',
            },
            editTsl: {
                icon: 'pencil',
                buttonSize: 'm',
            },
            import: {
                icon: 'upload',
                buttonSize: 'm',
            },
            download: {
                icon: 'download',
                buttonSize: 'm',
            },
            sendEmail: {
                icon: 'share',
                buttonSize: 'm',
            },
            relate: {
                icon: 'copy-link',
                buttonSize: 'm',
            },
            time: {
                icon: 'clock',
                buttonSize: 'm',
            },
            bulkSync: {
                icon: 'clock',
                buttonSize: 'm',
                class: 'bk-bulk-sync',
            },
        },
        sizes: {
            FIXED: 'fixed',
            SMALL: 'small',
            MEDIUM: 'medium',
            LARGE: 'large',
        },
        expertRequests: {
            MY_REQUESTS_TAB: 'myRequestsTab',
            REQUESTS_FOR_ME_TAB: 'requestsForMeTab',
        },
    },
    HTTP_STATUS_NOT_LOGGED_IN: 401,
    HTTP_STATUS_NOT_AUTHORIZED: 403,
    HTTP_STATUS_TOO_MANY_REQUESTS: 429,
    SPOTIQ_DATA_BATCH_SIZE: 5000,
    CHART_TOOLTIP_DELAY: 200,
    columnAdditionNotAllowedReasonTypes: {
        tooManyColumns: 'TOO_MANY_COLUMNS',
        complexQuery: 'COMPLEX_QUERY',
        missingUnderlyingAccess: 'MISSING_UNDERLYING_ACCESS',
        noColumnsSelected: 'NO_COLUMNS_SELECTED',
    },
    derivedColumnExprTypes: {
        DERIVATION_TYPE_LCR: 'LOGICAL_COLUMN_REFERENCE',
        DERIVATION_TYPE_EXPRESSION: 'EXPRESSION',
    },
    keyCodes: {
        UP_ARROW: 38,
        DOWN_ARROW: 40,
        ENTER_KEY: 13,
        TAB_KEY: 9,
        ESC_KEY: 27,
    },
    documentType: {
        ANSWER: 'ANSWER',
        SAVED_ANSWER: 'SAVED-ANSWER',
        REPLAY_ANSWER: 'REPLAY-ANSWER',
        PINBOARD: 'PINBOARD',
        WORKSHEET: 'WORKSHEET',
        VIEW: 'view',
    },
    dataColumnHeaders: {
        indexType: {
            MIN_WIDTH: 236,
        },
        geoConfig: {
            MIN_WIDTH: 182,
        },
        currencyType: {
            MIN_WIDTH: 180,
        },
    },
    DataExplorerViewModes: {
        PROP_VIEW: 'PROP_VIEW',
        DATA_VIEW: 'DATA_VIEW',
        SCHEMA_VIEW: 'SCHEMA_VIEW',
        DEPENDENTS_VIEW: 'DEPENDENTS_VIEW',
        SECURITY_VIEW: 'SECURITY_VIEW',
        PROFILE_VIEW: 'PROFILE_VIEW',
        ANALYZE_VIEW: 'ANALYZE_VIEW',
        A3_VIEW: 'A3_VIEW',
        EMBRACE_VIEW: 'EMBRACE_VIEW',
        SEARCH_IQ_VIEW: 'SEARCH_IQ_VIEW',
        SEARCH_ASSIST_VIEW: 'SEARCH_ASSIST_VIEW',
        CUSTOM_ACTIONS: 'CUSTOM_ACTIONS',
        SEARCH_CACHE_VIEW: 'SEARCH_CACHE_VIEW',
    },
    LOADING_SAMPLE_VALUE: '-',
    SPECIAL_VALUE_UNAVAILABLE: '601d5a70-d354-4aab-aa7c-b0f712f51ae3',
    joinWorkflow: {
        types: {
            INVALID_TYPE: 'INVALID_TYPE',
            DEFINE_MAPPING: 'DEFINE_MAPPING',
            EDIT_MAPPING: 'EDIT_MAPPING',
        },
    },
    preferenceKeys: {
        PANEL_STATE: 'PANEL_STATE',
        OPEN_ANSWER_EDIT_PANEL: 'OPEN_ANSWER_EDIT_PANEL',
        SUPPRESS_MANAGE_SOURCES_TOOLTIP: 'SUPPRESS_MANAGE_SOURCES_TOOLTIP',
        SUPPRESS_IN_USE_SOURCE_REMOVAL_WARNING: 'SUPPRESS_IN_USE_SOURCE_REMOVAL_WARNING',
        ANSWER_PAGE_ALERT: 'ANSWER_PAGE_ALERT_STATE',
        SEARCH_MODE: 'SEARCH_MODE',
        ANSWER_V2: 'ANSWER_V2',
        AI_ANSWER_GENERATION: 'AI_ANSWER_GENERATION',
        KPI_ANOMALIES: 'KPI_ANOMALIES',
        SPOT_IQ_V2: 'SPOT_IQ_V2',
        PINBOARD_V2: 'PINBOARD_V2',
        IS_FIRST_TIME_SPOT_IQ_USER: 'IS_FIRST_TIME_SPOT_IQ_USER',
        IS_SLACK_INITIALLY_CONNECTED: 'IS_SLACK_INITIALLY_CONNECTED',
        SAGE_SEARCH_BUTTON_TOUR_SEEN: 'SAGE_SEARCH_BUTTON_TOUR_SEEN',
        SAGE_SEARCH_BAR_COLLAPSED: 'SAGE_SEARCH_BAR_COLLAPSED',
        HOMEPAGE_EUREKA: 'HOMEPAGE_EUREKA',
        SEARCH_ASSIST_DATA_SOURCE: 'SEARCH_ASSIST_DATA_SOURCE',
        DATA_PANEL_V2: 'DATA_PANEL_V2',
        SHOW_NLS: 'SHOW_NLS',
        LIVEBOARD_GUIDE_COMPLETED: 'LIVEBOARD_GUIDE_COMPLETED',
        NUM_USERS_IN_ORG: 'NUM_USERS_IN_ORG',
        NEW_HOMEPAGE_EXPERIENCE: 'NEW_HOMEPAGE_EXPERIENCE',
        IS_FIRST_TIME_VERSION_HISTORY_USER: 'IS_FIRST_TIME_VERSION_HISTORY_USER',
        CONV_ASSIST: 'CONV_ASSIST',
        IS_FIRST_TIME_ENABLE_VERSION_HISTORY_USER: 'IS_FIRST_TIME_ENABLE_VERSION_HISTORY_USER',
        IS_FIRST_TIME_ANOMALY_ALERT_USER: 'IS_FIRST_TIME_ANOMALY_ALERT_USER',
        CHART_CONTEXT_MENU_EXPERIENCE: 'CHART_CONTEXT_MENU_EXPERIENCE',
        SPOTTER_AGENT: 'SPOTTER_AGENT',
    },
    preferenceValues: {
        panelState: {
            EXPANDED: 'EXPANDED',
            COLLAPSED: 'COLLAPSED',
            AUTO: 'AUTO',
        },
        searchMode: {
            SEARCH_ASSIST: 'SEARCH_ASSIST',
            SEARCHIQ: 'SEARCHIQ',
            CLASSIC: 'CLASSIC',
        },
        HOME_METADATA_LIST_CONFIG: 'HOME_METADATA_LIST_CONFIG',
        FAVOURITES_METADATA_LIST_CONFIG: 'FAVOURITES_METADATA_LIST_CONFIG',
        ANSWERS_METADATA_LIST_CONFIG: 'ANSWERS_METADATA_LIST_CONFIG',
        LIVEBOARDS_METADATA_LIST_CONFIG: 'LIVEBOARDS_METADATA_LIST_CONFIG',
        CREATED_BY_ME_METADATA_LIST_CONFIG: 'CREATED_BY_ME_METADATA_LIST_CONFIG',
        NEBULA_USERID_TO_ACTIVATION_TOKEN: 'NEBULA_USERID_TO_ACTIVATION_TOKEN',
    },
    decimalPrecision: {
        MIN: 2,
        MAX: 8,
    },
    pivotTable: {
        Areas: {
            ROW: 'row',
            COLUMN: 'column',
            DATA: 'data',
        },
        ascendingSort: 'asc',
        descendingSort: 'desc',
    },
    help: {
        releaseVersions: {
            RELEASE_4_2: '4.2',
            RELEASE_4_3: '4.3',
        },
        helpWidgetUrl: {
            keywords: {
                URL: '/reference/keywords.html',
            },
            chasmTrapLimitations: {
                URL: '/chasm-trap',
            },
            changeIndex: {
                URL: '/data-modeling-index',
            },
        },
        helpWidgetIcon: {
            BLINK_HOW_SEARCH_WORKS: 'rd-icon-video-m',
            BLINK_KEYWORDS: 'rd-icon-keywords-m',
            BLINK_RELEASE_NOTES: 'rd-icon-release-notes-m',
            BLINK_DOCUMENTATION: 'rd-icon-documentation-m',
            BLINK_DOWNLOADS: 'rd-icon-download-m',
            BLINK_DEFAULT_ICON: 'rd-icon-release-notes-m',
            note: 'rd-icon-release-notes-m',
        },
        support: {
            PHONE: '+1 800-508-7008 Ext. 1',
            EMAIL: 'support@thoughtspot.com',
        },
        COMMUNITY: 'https://community.thoughtspot.com/s/',
        CONTACT_SUPPORT: 'https://community.thoughtspot.com/customers/s/contactsupport',
    },
    action: {
        actionWidgetIcon: {
            BLINK_DEFAULT_ICON: 'bk-style-icon-clipboard-text',
        },
    },
    importData: {
        STATUS_SEPARATOR: '/',
    },
    profilePic: {
        SIZE_PRE_SCALE: 4096000,
        SIZE_POST_SCALE: 512000,
        DIMENSION: 400,
    },
    layout: {
        MIN_WIDTH: 8,
        MIN_WIDTH_STEP: 5,
        minHeight: {
            DEFAULT: 5,
            CHART: 10,
            TABLE: 14,
            HEADLINE: 8,
        },
    },
    tileSizes: {
        EXTRA_SMALL: 'xs',
        SMALL: 's',
        MEDIUM: 'm',
        LARGE: 'l',
        MEDIUM_SMALL: 'ms',
        LARGE_SMALL: 'ls',
        EXTRA_LARGE: 'xl',
    },
    communityLink: 'https://community.thoughtspot.com/',
    trainingLink: 'https://training.thoughtspot.com/',
    helpMenuItems: {
        help: {
            id: 'help',
            class: 'bk-action-help',
            icon: 'question-mark',
        },
        community: {
            id: 'community',
            class: 'bk-action-community',
            icon: 'community',
        },
        learn: {
            id: 'learn',
            class: 'bk-action-learn',
            icon: 'book',
        },
    },
    customREditorMenuItems: {
        load: {
            id: 'load',
            icon: 'bk-style-icon-download',
        },
        saveas: {
            id: 'save_as',
            icon: 'bk-style-icon-save',
        },
        overwrite: {
            id: 'overwrite',
            icon: 'bk-style-icon-edit',
        },
        share: {
            id: 'share',
            icon: 'bk-style-icon-share',
        },
    },
    metadataObjectMenuItems: {
        save: {
            id: 'save',
            class: 'bk-action-save',
            icon: 'save',
        },
        update: {
            id: 'update',
            class: 'bk-action-update',
            icon: 'save',
        },
        saveUntitled: {
            id: 'saveUntitled',
            class: 'bk-action-save-untitled',
            icon: 'save',
        },
        saveAsView: {
            id: 'saveAsView',
            class: 'bk-action-save-as-worksheet',
            icon: 'save-worksheet',
        },
        makeACopy: {
            id: 'makeACopy',
            class: 'bk-action-make-copy',
            icon: 'copy',
        },
        editACopy: {
            id: 'editACopy',
            class: 'bk-action-edit-copy',
            icon: 'copy',
        },
        copyLink: {
            id: 'embedDocument',
            class: 'bk-action-copy-link',
            icon: 'copy-link',
        },
        pinboardSnapshot: {
            id: 'pinboardSnapshot',
            class: 'bk-action-pinboard-snapshot',
            icon: 'download',
        },
        resetLayout: {
            id: 'resetLayout',
            class: 'bk-action-reset-layout',
            icon: 'reset',
        },
        schedule: {
            id: 'schedule',
            class: 'bk-action-schedule',
            icon: 'agenda',
        },
        schedulesList: {
            id: 'schedule-list',
            class: 'bk-action-schedules',
            icon: 'agenda',
        },
        share: {
            id: 'share',
            class: 'bk-action-share',
            icon: 'share',
        },
        addToCollection: {
            id: 'addToCollection',
            class: 'bk-action-add-to-collection',
            icon: 'collection',
        },
        addFilter: {
            id: 'addFilter',
            class: 'bk-add-filter',
            icon: 'funnel',
        },
        configureFilter: {
            id: 'configureFilter',
            class: 'bk-configure-filter',
            icon: 'configure-filter',
        },
        addFormula: {
            id: 'addFormula',
            class: 'bk-add-formula',
            icon: 'formula',
        },
        searchOnTop: {
            id: 'searchOnTop',
            class: 'bk-search-on-top',
            icon: 'magnifying-glass',
        },
        spotIQAnalyze: {
            id: 'spotIQAnalyze',
            class: 'bk-spotiq-analyze',
            icon: 'bulb',
        },
        explainInsight: {
            id: 'explainInsight',
            class: 'bk-explain-insight',
            icon: 'bulb',
        },
        spotIQFollow: {
            id: 'spotIQFollow',
            class: 'bk-action-spotiq-follow',
            icon: 'follow',
        },
        shareViz: {
            id: 'shareViz',
            class: 'bk-action-share',
            icon: 'share',
        },
        replaySearch: {
            id: 'replaySearch',
            class: 'bk-replay-search',
            icon: 'replay-search',
        },
        showUnderlyingData: {
            id: 'showUnderlyingData',
            class: 'bk-show-underlying-data-trigger',
            icon: 'show-underlying-data',
        },
        download: {
            id: 'download',
            class: 'bk-download-viz',
            icon: 'download',
        },
        downloadAsPng: {
            id: 'downloadAsPng',
            class: 'bk-download-as-png',
            icon: 'download',
        },
        downloadPinboardAsPdf: {
            id: 'downloadPinboardAsPdf',
            class: 'bk-download-pinboard-as-pdf',
            icon: 'download',
        },
        downloadAsPdf: {
            id: 'downloadAsPdf',
            class: 'bk-download-as-pdf',
            icon: 'download',
        },
        downloadAsCsv: {
            id: 'downloadAsCSV',
            class: 'bk-download-as-csv',
            icon: 'download',
        },
        downloadAsXlsx: {
            id: 'downloadAsXLSX',
            class: 'bk-download-as-xlsx',
            icon: 'download',
        },
        downloadTrace: {
            id: 'downloadTrace',
            class: 'bk-download-trace',
            icon: 'download',
        },
        exportTSL: {
            id: 'exportTSL',
            class: 'bk-export-tsl',
            icon: 'download',
        },
        importTSL: {
            id: 'importTSL',
            class: 'bk-import-tsl',
            icon: 'upload',
        },
        updateTSL: {
            id: 'updateTSL',
            class: 'bk-update-tsl',
            icon: 'upload',
        },
        editTSL: {
            id: 'editTSL',
            class: 'bk-edit-tsl',
            icon: 'pencil',
        },
        presentation: {
            id: 'present',
            class: 'bk-viz-maximize-btn',
            icon: 'present',
        },
        toggleSize: {
            id: 'toggleSize',
            class: 'bk-viz-toggle-btn',
        },
        edit: {
            id: 'edit',
            class: 'bk-viz-context-btn',
            icon: 'pencil',
        },
        editTitle: {
            id: 'editTitle',
            class: 'bk-viz-edit-title-btn',
            icon: 'edit-text',
        },
        remove: {
            id: 'delete',
            class: 'bk-viz-delete-btn',
            icon: 'trash-can',
        },
        ungroup: {
            id: 'ungroup',
            class: 'ungroup-m',
            icon: 'group-undo',
        },
        describe: {
            id: 'describe',
            class: 'bk-viz-describe-btn',
            iconClass: 'bk-style-icon-pinboard',
        },
        relate: {
            id: 'relate',
            class: 'bk-relate-answer',
            icon: 'copy-link',
        },
        customizeHeadlines: {
            id: 'customizeHeadlines',
            class: 'bk-customize-headlines',
            icon: 'funnel',
        },
        pinboardInfo: {
            id: 'pinboardInfo',
            class: 'bk-pinboard-info',
            icon: 'information',
        },
        sendAnswerFeedback: {
            id: 'sendFeedback',
            class: 'bk-action-send',
            icon: 'paper-plane',
        },
        customAction: {
            id: 'customAction',
            class: 'bk-custom-action',
            icon: 'note',
        },
        downloadEmbraceQueries: {
            id: 'downloadEmbraceQueries',
            class: 'bk-custom-action',
            icon: 'note',
        },
        pin: {
            id: 'pin',
            icon: 'pin',
            class: 'bk-action-viz-pin',
        },
        analysisInfo: {
            id: 'analysisInfo',
            icon: 'information',
            class: 'bk-action-analysis-info',
        },
        subscription: {
            id: 'subscription',
            icon: 'cog',
            class: 'bk-action-subscription',
        },
        explore: {
            id: 'explore',
            class: 'bk-action-explore',
        },
        requestAccess: {
            id: 'requestAccess',
            class: 'bk-pinboard-request-access',
        },
        createMonitor: {
            id: 'createMonitor',
            class: 'bk-action-monitor',
            icon: 'create-monitor',
        },
        manageMonitor: {
            id: 'manageMonitor',
            class: 'bk-action-monitor',
            icon: 'monitor',
        },
        liveboardUsers: {
            id: 'liveboardUsers',
        },
        addToFavorites: {
            id: 'addToFavorites',
            class: 'bk-favorite-btn',
        },
        editDetails: {
            id: 'editDetails',
            class: 'bk-edit-btn',
        },
        generateAISynonyms: {
            id: 'generateAISynonyms',
            class: 'bk-action-generate-ai-synonyms',
            icon: 'generate-ai-synonyms',
        },
        deleteAISynonyms: {
            id: 'deleteAISynonyms',
            class: 'bk-action-delete-ai-synonyms',
            icon: 'delete-ai-synonyms',
        },
        convertToModel: {
            id: 'convertToModel',
            class: 'bk-arrow-up-btn',
            icon: 'arrow-up',
        },
        publish: {
            id: 'publish',
            class: 'bk-action-publish',
        },
        managePublishing: {
            id: 'managePublishing',
            class: 'bk-action-manage-publishing',
        },
        unpublish: {
            id: 'unpublish',
            class: 'bk-action-unpublish',
        },
    },
    adminSection: {
        userManagement: {
            tabId: 'user-management',
            tabUsers: {
                id: 'users',
            },
            tabGroups: {
                id: 'groups',
            },
            tabRoles: {
                id: 'roles',
            },
        },
        dataManagement: {
            tabId: 'data-management',
            tabBusinessDataModel: {
                id: 'business-data-model',
                DATA_MODEL_FILE_NAME: 'model.tsv',
            },
            tabDataSecurity: {
                id: 'data-security',
                SECURITY_FILE_NAME: 'security.xls',
            },
        },
        healthManagement: {
            tabId: 'health-management',
            tabOverview: {
                guid: '7d610c97-11dd-4137-940c-3eda0b1cb434',
                id: 'overview',
            },
            tabData: {
                guid: '7ba1d5d8-9cc0-4ec5-ac77-dd545c66dc75',
                id: 'data',
            },
            tabDatabase: {
                guid: '7632ad88-665a-4eaa-ba72-064666612087',
                id: 'database',
            },
            tabAlert: {
                guid: '09ec5619-057b-4b9e-b2fc-98f6905e47e6',
                id: 'alert',
            },
            tabCluster: {
                guid: 'f43e3f57-859f-4665-ac78-82ea72ec0980',
                id: 'cluster',
            },
            tabEmbrace: {
                guid: '9f542e6b-6c06-4254-b546-a3b50e0125e1',
                id: 'embrace',
            },
            tabEmbraceOrgs: {
                guid: 'ae98106c-2078-402a-9ee3-5cf528253cbb',
                id: 'embraceOrgs',
            },
        },
        styleCustomization: {
            tabId: 'style-customization',
            tabRules: {
                id: 'style-customization-rules',
            },
            tabResources: {
                id: 'style-customization-resources',
            },
        },
        helpCustomization: {
            tabId: 'help-customizer',
        },
        jobManagement: {
            tabId: 'job-management',
        },
        actionCustomization: {
            tabId: 'action-customizer',
        },
    },
    IGNORED_API_CALL_ERROR: new Error('Ignored older API call'),
    adminUI: {
        listColId: {
            DISPLAYED_NAME: 'displayNameCol',
            NAME: 'nameCol',
            CREATED_AT: 'dateModifiedCol',
            AUTHOR: 'authorCol',
        },
        listColClass: {
            DISPLAYED_NAME: 'bk-display-name',
            NAME: 'bk-name',
            CREATED_AT: 'bk-time-and-author',
            AUTHOR: 'bk-profile-pic-container',
        },
        tabId: {
            GROUPS_TAB: 'groupsTab',
            ROLES_TAB: 'rolesTab',
            USERS_TAB: 'usersTab',
            DEFAULT_PINBOARD_TAB: 'pinboardTab',
            EMAIL_TAB: 'emailTab',
            ORGS_TAB: 'orgsTab',
        },
        formFields: {
            type: {
                PLAIN: 'plain',
                SELECT: 'select',
                CHECKBOX: 'checkbox',
                TEXTAREA: 'textarea',
                PASSWORD: 'password',
            },
            inputType: {
                TEXT: 'text',
                EMAIL: 'email',
                PASSWORD: 'password',
            },
            fields: {
                NAME: 'name',
                DISPLAYNAME: 'displayName',
                DESCRIPTION: 'description',
                PASSWORD: 'password',
                CONFIRM_PASSWORD: 'confirmPassword',
                EMAIL: 'email',
                VISIBILITY: 'visibility',
                MESSAGE: 'message',
            },
        },
    },
    dataFilter: {
        FILTER_TYPES: {
            IS_NULL: {
                noText: true,
            },
            IS_NOT_NULL: {
                noText: true,
            },
        },
    },
    debugging: {
        DEBUG_INFO_DOWNLOAD_TRIGGER_ALPHA_KEY_CODE: 75,
        DEBUG_FILE_NAME_PATTERN: 'thoughtspot-ui-debug-info-{1}.json',
    },
    jobProtoKeys: {
        AUTHOR: 'author_id',
        WORKSHEET_ID: 'worksheet_id',
        PINBOARDS: 'pinboard_ids',
        GROUPS: 'group_ids',
        USERS: 'user_ids',
        EMAILS: 'email_to',
        FORMAT: 'file_format',
        NAME: 'name',
        GATING: 'gating_function',
        DESCRIPTION: 'description',
        A3_REQUEST: 'AnalysisRequest',
        MATERIALIZE_REQUEST: 'MaterializeRequest',
        EXPORT_REQUEST: 'export_request',
        USE_CUSTOM_EMBED_URLS: 'use_custom_embed_urls',
        AI_HIGHLIGHTS_SCHEDULE_CONFIG: 'ai_highlights_schedule_config',
        EMAIL_OPTIONS: 'email_options',
    },
    vizTypes: {
        CHART: 'CHART',
        TABLE: 'TABLE',
        HEADLINE: 'HEADLINE',
        FILTER: 'FILTER',
    },
    tokenTypeEnum: {
        MEASURE: 1,
        ATTRIBUTE: 2,
        FILTER: 3,
    },
    dataSourcePreview: {
        FOOTER_TEXT: ' and {1} more.',
    },
    DAY_OF_WEEK_FORMAT: 'e',
    DAY_IN_MONTH_FORMAT: 'e',
    DAY_IN_QUARTER_FORMAT: 'e',
    DAY_IN_YEAR_FORMAT: 'j',
    MONTH_IN_YEAR_FORMAT: 'm',
    MONTH_IN_QUARTER_FORMAT: 'm',
    WEEK_IN_YEAR_FORMAT: 'V',
    TRACE_COLLECTOR_NAME: 'BlinkWorkflowManager',
    colorPickerResolution: 8,
    colorLayout: {
        COLOR_COUNT_RAINBOW: 6,
        COLOR_COUNT_DEFAULT: 8,
        COLOR_VARIATION_COUNT: 5,
    },
    PRIMARY_COLOR_HUE_IDX: 2,
    SECONDARY_COLOR_HUE_IDX: 1,
    COLOR_HUE_COUNT: 5,
    defaultAppPanelColor: '#303540',
    defaultAppBackground: '#eef1f4',
    defaultColorPalette: {
        RED: ['#F9B3B9', '#F47E89', '#F04152', '#B6313E', '#721F27'],
        PURPLE: ['#D1C0FB', '#B094F8', '#8C62F5', '#6A4ABA', '#422E75'],
        BLUE: ['#ABC7F9', '#71A1F4', '#2E75F0', '#2359B6', '#163772'],
        TEAL: ['#B5ECF2', '#82DFE9', '#48D1E0', '#369FAA', '#22636B'],
        YELLOW: ['#FDE9AF', '#FCD977', '#FCC838', '#BF982A', '#785F1A'],
        GREY: ['#BEC6D0', '#A2ACBA', '#747E8C', '#47515F', '#2F3947'],
        GREEN: ['#9BE5CB', '#56D3A8', '#06BF7F', '#049160', '#025B3C'],
        ORANGE: ['#FFCCB3', '#FFA97E', '#FF8142', '#C26232', '#7A3D1F'],
    },
    gradientColorsColorPalette: {
        BLACK: ['#777E8B', '#C0C6CF', '#000000', '#EAEDF2', '#FFFFFF'],
        RED: ['#E22B3D', '#F9B3B9', '#B6313E', '#FFEBEC', '#FFF0F0'],
        ORANGE: ['#FF8142', '#FFCCB3', '#C26232', '#FFEEE5', '#FFF5F0'],
        PURPLE: ['#8C62F5', '#D1C0FB', '#6A4ABA', '#F0EBFF', '#F7F5FF'],
        GREEN: ['#06BF7F', '#9BE5CB', '#049160', '#E0F8EF', '#EDFFF9'],
        YELLOW: ['#FCC838', '#FDE9AF', '#BF982A', '#FFF8E5', '#FFFBF0'],
        TEAL: ['#48D1E0', '#B5ECF2', '#369FAA', '#E1F7FA', '#EDFDFF'],
        BLUE: ['#2770EF', '#ABC7F9', '#2359B6', '#DEE8FA', '#F2F7FF'],
    },
    multiHueColorsColorPalette: {
        RED_YELLOW: [
            '#ffffb2',
            '#fddd87',
            '#fba35d',
            '#f75534',
            '#f9140a',
            '#d70315',
            '#b10026',
        ],
        BLUE: [
            '#f7fbff',
            '#cfe0f9',
            '#a6c6f3',
            '#77aded',
            '#3295e6',
            '#287ac6',
            '#1e60a6',
            '#144888',
            '#08306b',
        ],
        YELLOW_GREEN: [
            '#ffffe5',
            '#d5f0ca',
            '#abe1af',
            '#7dd295',
            '#46c27b',
            '#34a165',
            '#238150',
            '#11623c',
            '#004529',
        ],
        PINK: [
            '#f7f4f9',
            '#f5cfec',
            '#f1aadf',
            '#eb83d2',
            '#e356c5',
            '#c44198',
            '#a52c6d',
            '#861744',
            '#67001f',
        ],
        YELLOW_GREEN_BLUE: [
            '#ffffd9',
            '#d7f1da',
            '#abe2db',
            '#78d4db',
            '#1ac5db',
            '#2397b9',
            '#226c97',
            '#194377',
            '#081d58',
        ],
        REDS: [
            '#fff5f0',
            '#fee0d2',
            '#fcbba1',
            '#fc9272',
            '#fb6a4a',
            '#ef3b2c',
            '#cb181d',
            '#a50f15',
            '#67000d',
        ],
        PURPLES: [
            '#fcfbfd',
            '#e6d0f8',
            '#cda6f3',
            '#b27ced',
            '#9450e6',
            '#7e3dcb',
            '#692bb0',
            '#541796',
            '#3f007d',
        ],
    },
    helpCardColors: {
        YELLOW: 'bk-yellow',
        BLUE: 'bk-blue',
        GREEN: 'bk-green',
        RED: 'bk-red',
        LIGHT_BLUE: 'bk-light-blue',
        PURPLE: 'bk-purple',
    },
    paginationTabs: {
        PAGINATION_TAB_THRESHOLD: 7,
    },
    eventCollector: {
        EVENT_BATCH_THRESHOLD: 1,
    },
    legendTopSpacing: {
        VERTICAL: -42,
        HORIZONTAL: 0,
    },
    cardTray: {
        size: {
            SMALL: 's',
            MEDIUM: 'm',
            EXTRA_SMALL: 'xs',
            SMALL_SHORT: 'short',
        },
    },
    cardCount: {
        ACTIVITY_CARDS: 24,
        TRENDING_CARDS: 24,
        RECENTLY_VIEWED_CARDS: 24,
        HOMEPAGE_INSIGHTS_CARDS: 24,
        PINBOARD_INSIGHT_CARDS: 4,
        FAVORITE_CARDS: 24,
    },
    trending: {
        GLOBAL: 'global',
        RECENT: 'recent',
    },
    languages: {
        morning: [
            { name: 'Spanish', greeting: 'Buenos días' },
            { name: 'French', greeting: 'Bonjour' },
            { name: 'German', greeting: 'Guten morgen' },
            { name: 'Italian', greeting: 'Buongiorno' },
            { name: 'Portuguese', greeting: 'Bom dia' },
            { name: 'Swahili', greeting: 'Habari za asubuhi' },
            { name: 'Finnish', greeting: 'Hyvää huomenta' },
            { name: 'Swedish', greeting: 'God morgon' },
            { name: 'Icelandic', greeting: 'Góðan daginn' },
            { name: 'Hawaiian', greeting: 'Aloha kakahiaka' },
            { name: 'Nepali', greeting: 'Śubha - prabhāta' },
            { name: 'Thai', greeting: 'S̄wạs̄dī txn chêā' },
            { name: 'Welsh', greeting: 'Bore da' },
            { name: 'Korean', greeting: 'Joh-eun achim' },
            { name: 'Hindi', greeting: 'S̄hubh prabhat' },
        ],
        afternoon: [
            { name: 'Spanish', greeting: 'Buenas tardes' },
            { name: 'French', greeting: 'Bon après-midi' },
            { name: 'German', greeting: 'Guten nachmittag' },
            { name: 'Italian', greeting: 'Buon pomeriggio' },
            { name: 'Portuguese', greeting: 'Boa tarde' },
            { name: 'Swahili', greeting: 'Mchana mzuri' },
            { name: 'Finnish', greeting: 'Hyvää iltapäivää' },
            { name: 'Swedish', greeting: 'God eftermiddag' },
            { name: 'Icelandic', greeting: 'Góðan daginn' },
            { name: 'Hawaiian', greeting: 'Aloha ʻauinalā' },
            { name: 'Nepali', greeting: "Śubha di'um̐sō" },
            { name: 'Thai', greeting: 'S̄wạs̄dī txn b̀āy' },
            { name: 'Welsh', greeting: 'Prynhawn da' },
            { name: 'Korean', greeting: 'Annyeonghaseyo' },
            { name: 'Hindi', greeting: 'S̄hubh din' },
        ],
        evening: [
            { name: 'Spanish', greeting: 'Buenas noches' },
            { name: 'French', greeting: 'Bonne nuit' },
            { name: 'German', greeting: 'Guten abend' },
            { name: 'Italian', greeting: 'Buonasera' },
            { name: 'Portuguese', greeting: 'Boa noite' },
            { name: 'Swahili', greeting: 'Habari za jioni' },
            { name: 'Finnish', greeting: 'Hyvää iltaa' },
            { name: 'Swedish', greeting: 'God kväll' },
            { name: 'Icelandic', greeting: 'Gott kvöld' },
            { name: 'Hawaiian', greeting: 'Aloha ahiahi' },
            { name: 'Nepali', greeting: 'Śubha sandhyā' },
            { name: 'Thai', greeting: 'S̄wạs̄dī txn yĕn' },
            { name: 'Welsh', greeting: 'Noswaith dda' },
            { name: 'Korean', greeting: 'Annyeonghaseyo' },
            { name: 'Hindi', greeting: 'S̄hubh sandhya' },
        ],
    },
    gridTableDataType: {
        BOOL: 'BOOL',
        STRING: 'STRING',
    },
    commonChartConfig: {
        accessibility: {
            enabled: true,
            keyboardNavigation: {
                enabled: true,
            },
        },
    },
    docsUrl: {
        answerExpertQuestion: '/end-user/search/answer-expert-question.html',
        configureBackup: '/admin/backup-restore/configure-backup.html',
        configureSAML: '/authentication-integration',
        connection: '',
        createBkpRestoreSchedule: '/admin/backup-restore/how-to-create-a-schedule.html',
        internalAuth: '/authentication-local',
        ldapConfigAD: '/ldap-config-ad',
        linkedFilter: '/complex-search/linked-filters.html',
        materializeView: {
            viewSchema: '/#/schema-viewer/table/{id}',
            shardingDoc: '/admin/loading/sharding.html',
            mvDoc: '/admin/loading/materialized-views.html',
        },
        nasMount: '/admin/setup/NAS-mount.html',
        overviewSnapshot: '/admin/backup-restore/overview-snapshot.html',
        reverseTunnelSupport: '/admin/setup/work-with-ts-support.html#set-up-a-reverse-tunnel-for-support',
        searchIq: '/end-user/search/about-searchiq.html',
        searchOptimize: '/end-user/search/searchiq-optimize.html',
        setUpRelayHost: '/admin/setup/set-up-relay-host.html',
        sslConfig: '/admin/setup/SSL-config.html',
        takeBackup: '/admin/backup-restore/take-backup.html',
        tsl: '/tml',
        zip: '/tml-import-export-multiple',
        statusPortal: '/status',
        spotterBestPractices: 'spotter-business',
    },
    deeplink: {
        userWishesBrowserExperience: 'userWishesBrowserExperience',
    },
    eureka: {
        toggleDiscover: {
            duration: 6,
        },
        focusOnInit: 'EUREKA_FOCUS_ON_INIT',
    },
    everyWhere: {
        visualisation: 'Viz',
        search: 'Search',
        pinboard: 'Pinboard',
        fullApp: 'Full App',
        dataSources: 'dataSources',
        embedApp: 'embedApp',
        sdkVersion: 'sdkVersion',
        hostAppUrl: 'hostAppUrl',
    },
    seekwell: {
        authRedirectEvent: 'SEEKWELL_AUTH_REDIRECT',
        authRedirectParams: {
            destinationId: 'destination_id',
            status: 'status',
            error: 'error',
            reauthFlag: 'reauth_flag',
        },
    },
    spotApps: {
        connectorAuthRedirectEvent: 'SPOTAPPS_CONNECTOR_AUTH_REDIRECT',
        connectorAuthRedirectParams: {
            FIVETRAN: {
                connectorId: 'id',
            },
        },
    },
    adminLearnMore: {
        helpCustomization: 'admin/ts-cloud/customize-help.html',
        smtp: 'admin/setup/set-up-relay-host.html',
        ssl: 'admin/setup/SSL-config.html',
        ssh: 'admin/setup/work-with-ts-support.html#set-up-a-reverse-tunnel-for-support',
        nas: 'admin/setup/NAS-mount.html',
        snapshot: 'admin/backup-restore/overview-snapshot.html',
    },
    blinkGeneratedErrors: {
        CALLOSUM_UNKNOWN_ERROR: '9500',
        CALLOSUM_API_TIMEOUT: '9501',
        SAGE_UNKNOWN_ERROR: '9502',
        SAGE_API_TIMEOUT: '9503',
        INCOMPLETE_DOCUMENT: '9504',
        SAGE_INDEXING: '9505',
        OBJECT_MISSING: '9506',
        SAGE_UNAVAILABLE: '9507',
        INCOMPLETE_VIZ_DOC: '9508',
        NO_SESSION_FOUND: '10097',
    },
    localClusterId: 'local',
    searchCache: {
        ENABLED_CONNECTION_TYPES: ['RDBMS_SNOWFLAKE'],
    },
    orgs: {
        ALL_ID: -1,
        MASTER_ID: 0,
    },
    themeType: {
        DARK: 'dark',
        TWO_TONE: 'two-tone',
        CUSTOM: 'custom',
    },
    themeColor: {
        DARK: '#1D232FFF',
        TWO_TONE: '#FFFFFFFF',
        CUSTOM: '#1D232F',
        RADIANT_LIGHT: 'RADIANT_LIGHT',
        RADIANT_DARK: 'RADIANT_DARK',
    },
    radiantThemeMode: {
        LIGHT: 'light',
        DARK: 'dark',
        BRAND: 'brand',
    },
    QUERY_FEEDBACK: 'query-feedback',
    FRAGMENT_FEEDBACK: 'fragment-feedback',
    UPDATE_FEEDBACK: 'update-feedback',
    DELETE_FEEDBACK: 'delete-feedback',
    SYSTEM_GENERATED: 'SYSTEM_GENERATED',
    DEFAULT_DATASOURCE_ID: '43121d86-347a-4dbb-bea8-5e5bb899e427',
    parentDataTypeMap: {
        DATE: 'DATE',
        DATE_TIME: 'DATE',
        DOUBLE: 'INT',
        FLOAT: 'INT',
        INT32: 'INT',
        INT64: 'INT',
        TIME: 'DATE',
    },
    spotterPlanTypes: {
        standaloneSpotter: 'standaloneSpotter',
        tsaSpotter: 'tsaSpotter',
        tsaSpotterDisabled: 'tsaSpotterDisabled',
    },
    USER_LOCALE: 'USER_LOCALE',
    UNAUTHENTICATED_FAILURE: 'UNAUTHENTICATED_FAILURE',
};
//# sourceMappingURL=blink-constants.js.map